module.exports = __webpack_public_path__ + "static/media/md-color-wand.cc9341d0.svg";